export default __webpack_public_path__ + "static/media/Descarga.92f3a19c.svg";